import { CONSTANTS } from '../data.js';

export const calculateStats = (playerDragon) => {
  const baseDragon = CONSTANTS.DRAGONS[playerDragon.name];
  if (!baseDragon.stats) {
    return { attack: 0, speed: 0, defense: 0, strength: 0, physique: 0, hiddenPower: 0 };
  }
  const multiplier = CONSTANTS.LEVEL_MULTIPLIERS[playerDragon.level] || 1;
  
  return {
    attack: Math.ceil(baseDragon.stats.attack * multiplier),
    speed: Math.ceil(baseDragon.stats.speed * multiplier),
    defense: Math.ceil(baseDragon.stats.defense * multiplier),
    strength: Math.ceil(baseDragon.stats.strength * multiplier),
    physique: Math.ceil(baseDragon.stats.physique * multiplier),
    hiddenPower: Math.ceil(baseDragon.stats.hiddenPower * multiplier),
  };
};

export const calculateTotalStats = (playerDragon) => {
  const stats = calculateStats(playerDragon);
  return Object.values(stats).reduce((sum, val) => sum + val, 0);
};

export const calculateCoinsPerSecond = (playerDragons) => {
  let total = 0;
  playerDragons.forEach(pd => {
    const dragonData = CONSTANTS.DRAGONS[pd.name];
    total += dragonData.coinsPerSecond * (CONSTANTS.COIN_GENERATION_LEVEL_MULTIPLIER ** (pd.level - 1));
  });
  return total;
};

export const getAssetKey = (name) => name.replace(/ |-/g, '');
